import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders, HttpParams} from '@angular/common/http';
import { Observable, pipe, Subject, throwError } from 'rxjs';
import {UntypedFormGroup,UntypedFormControl} from '@angular/forms'
import { catchError,retry, tap } from 'rxjs/operators'
import { error } from 'jquery';
import {configData} from '../config';
import { newVulClass } from './newVulClass';
import { VulClass } from './VulClass';
import { IVul } from '../user-view-vulnerability/IVul';

const options ={
  headers : new HttpHeaders({
    'Content-Type' : 'application/json',
    Authorization : 'Basic ' +btoa('MyBuddyUser:h8i9h35Si5YXFdEFx')
  })
  // params : new HttpParams().set('username','MyBuddyUser')
};


@Injectable({
  providedIn: 'root'
})
export class NewVulnerabilityService {

  APIUrl = configData.apiURL;//to get API url from config file
  
  constructor(private http : HttpClient) { }

  private _refreshNeeded$ = new Subject<void>();
  VuData: Observable<any>;
  formData : newVulClass = new newVulClass();
  //data: Observable<VulClass[]>;
  data : any[];

  form : UntypedFormGroup = new UntypedFormGroup({
    $key: new UntypedFormControl(null)
  });

//#region NewVulnerability API Call
  getNewVulnerabilityList(id : any) : Observable<any[]>{     
    return this.http.get<any>(this.APIUrl+'/NewVulnerability/'+id,options);
  }

  addVulnerability(val : any){
    //console.log("val " +val.DeparmentName);
    return this.http.post(this.APIUrl+'/NewVulnerability',val,options)
    // .pipe(
    //   retry(2),
    //   catchError(this.handleError)
    // );
}

getusersldap(userid : any) : Observable<any>{
  return this.http.get(this.APIUrl+'/NewVulnerability/GetUsersLDAP/'+userid,options);  
}

updateVulnerability(val : any){
  return this.http.put(this.APIUrl+'/NewVulnerability',val,options)
  // .pipe(
  //   retry(2),
  //   catchError(this.handleError)
  // );
}

get refreshNeeded$(){
  this._refreshNeeded$.complete();
  return this._refreshNeeded$;
}

updateVulnerabilityData(val : any) : Observable<any>{
  console.log("updated ");
  return this.http
  .put(this.APIUrl+'/NewVulnerability/VUUpdate',val,options)
  .pipe(
    tap(() => { console.log("refresh tap");
      this._refreshNeeded$.next();
      this._refreshNeeded$.complete();
    })
  );
}

getNewVulDropDownData() : Observable<any[]>{
  return this.http.get<any>(this.APIUrl+'/NewVulnerability/GetNewVulDDL',options)
  // .pipe(
  //   retry(2),
  //   catchError(this.handleError)
  // );
}

getNewDelDropDownData(FilterData : any) : Observable<any>{ 
  console.log("This is to test DD data of delegate")     
  return this.http
  .put(this.APIUrl+'/NewVulnerability/GetNewDelDDL',FilterData,options)
  .pipe(
    tap(
      () => {
        this._refreshNeeded$.next();
        this._refreshNeeded$.complete();       
      }
    )
  );
 }

// getEVDropDownData( DDValue:any){
//   return this.http.get<any>(this.APIUrl+'/NewVulnerability/GetEVDDL',DDValue)
//   // .pipe(
//   //   retry(2),
//   //   catchError(this.handleError)
//   // );
// }

getEVClientDDData() : Observable<any>{
    return this.http.get<any>(this.APIUrl+'/NewVulnerability/GetEVClientDDL',options)
}

getEVContrNameDDData() : Observable<any>{
  return this.http.get<any>(this.APIUrl+'/NewVulnerability/GetEVContrNameDDL',options)
}

getEVContrNumData() : Observable<any>{
  return this.http.get<any>(this.APIUrl+'/NewVulnerability/GetEVContrNumDDL',options)
}



getEVCVEDropDownData() : Observable<any[]>{
  return this.http.get<any>(this.APIUrl+'/NewVulnerability/GetEVCVEDDL',options)
  // .pipe(
  //   retry(2),
  //   catchError(this.handleError)
  // );
}

getEVMailData() : Observable<any[]>{
  return this.http.get<any>(this.APIUrl+'/NewVulnerability/GetEVMailData',options)
  // .pipe(
  //   retry(2),
  //   catchError(this.handleError)
  // );
}

//#endregion NewVulnerability API Call
getHomeGridData() : Observable<any[]>{
  return this.http.get<any>(this.APIUrl+'/NewVulnerability/GetHomeGrid',options)
  // .pipe(
  //   retry(2),
  //   catchError(this.handleError)
  // );
}

refreshListData(){
  console.log("grid url : "+this.APIUrl);
  this.http.get<any>(this.APIUrl+'/NewVulnerability/GetHomeGridData',options)
  .toPromise()
  .then(res => this.data = res as VulClass[]);
  console.log("ref data : ");
  console.log(this.data);
}

public getGridData() : Observable<any[]>{
  return this.http.get<any>(this.APIUrl+'/NewVulnerability/GetHomeGridData',options);
  //this.data = this.http.get<VulClass[]>(this.APIUrl+'/NewVulnerability/GetHomeGridData');
  //return this.data;
}

public getAssessGridData() : Observable<any[]>{
  return this.http.get<any>(this.APIUrl+'/NewVulnerability/GetAssessGridData',options);
}

//#region  Assessment SAPI Call
addAssessment(val : any){  
  return this.http.post(this.APIUrl+'/Assessment',val,options)
}

UpdateAssessment(val : any){
return this.http.put(this.APIUrl+'/Assessment/UpdateAssessment',val,options)
}
UpdateGCCAssessment(val : any){
  return this.http.put(this.APIUrl+'/Assessment/UpdateGCCAssessment',val,options)
  }

getAssessDataList(id : any) : Observable<any[]>{     
  return this.http.get<any>(this.APIUrl+'/Assessment/'+id,options);
}

//#endregion

addError(errorMessage : any){
  console.log("val Error "+errorMessage );
  //let err = 
  let url = this.APIUrl+'/NewVulnerability/SendExcepToDB';
  return this.http.post(url,errorMessage,options);
   //this.http.post(this.APIUrl+'/NewVulnerability/SendExcepToDB',errorMessage);   
  // .pipe(
  //   retry(2),
  //   catchError(this.handleError)
  // );
}

getVulnerabilityUserView(FilterData : any) : Observable<any>{      
  return this.http
 .put(this.APIUrl+'/NewVulnerability/GetUserView',FilterData,options);
//  return this.http
//  .put(this.APIUrl+'/NewVulnerability/GetUserView',FilterData,options)
//  .pipe(
//    tap(
//      () => {
//        this._refreshNeeded$.next();
//        this._refreshNeeded$.complete();       
//      }
//    )
//  );
}

getVulnerabilityUserViewContract(FilterData : any) : Observable<any>{      
  return this.http
  .put(this.APIUrl+'/NewVulnerability/GetUserViewContract',FilterData,options)
  .pipe(
    tap(
      () => {
        this._refreshNeeded$.next();
        this._refreshNeeded$.complete();       
      }
    )
  );
 }

UpdateVulUserView(val : any):Observable<any>{
  //return this.http.put(this.APIUrl+'/NewVulnerability/UpdateUserView',val)
  return this.http
  .put(this.APIUrl+'/NewVulnerability/UpdateUserView',val,options)
  .pipe(
    tap(() => { console.log("refresh tap");
      this._refreshNeeded$.next();
      this._refreshNeeded$.complete();
    })
  )
}

getMaintenanceData() : Observable<any[]>{
  console.log("Entered getMaintenanceData!")
  return this.http.get<any>(this.APIUrl+'/NewVulnerability/GetMaintenanceData',options)
}

getEditVulData(FilterData : any) : Observable<any>{
  return this.http
  .put(this.APIUrl+'/NewVulnerability/GetEditVulData',FilterData,options)
  .pipe(
    tap(
      () => {
        this._refreshNeeded$.next();
        this._refreshNeeded$.complete();       
      }
    )
  );
}

UpdateMaintenance(val : any):Observable<any>{
  return this.http.put(this.APIUrl+'/NewVulnerability/UpdateMaintenanceData',val,options)
}

UpdateEVMaintenance(val : any){  
  return this.http
  .put(this.APIUrl+'/NewVulnerability/UpdateEVMaintenanceData',val,options)
  .pipe(
    tap(() => { console.log("refresh tap");
      this._refreshNeeded$.next();
      this._refreshNeeded$.complete();
    })
  )
}

public handleError(error: HttpErrorResponse) {
   console.error("handleerr");
  let errorMessage : string = '';

  if (error.status === 0) {
    // A client-side or network error occurred. Handle it accordingly.
    errorMessage = `Client Side error occurred: ${error.error}`;
    // console.error('An error occurred:', error.error);
    
  } else {
    // The backend returned an unsuccessful response code.
    // The response body may contain clues as to what went wrong.
    // console.error(
    //   `Backend returned code ${error.status}, body was: `, error.error);
      errorMessage = `Backend returned code ${error.status}, body was: ${error.error}`;
      
  }
  // Return an observable with a user-facing error message.
  errorMessage += ',Something bad happened, please try again later.';
  this.addError(errorMessage);
  // let ab = this.addError(error);
  return throwError(errorMessage);
  
}

chkValidCVETitle(val : any) : Observable<any>{
  console.log("cve tit ")
  console.log(val);
  return this.http.put(this.APIUrl+'/NewVulnerability/chkCVETitle',val,options)
  // .pipe(
  //   retry(2),
  //   catchError(this.handleError)
  // );
}

verifyContEid(val : any) : Observable<any>{
  console.log("verify ")
  console.log(val);
  return this.http.get<any>(this.APIUrl+'/NewVulnerability/verifyContEID/'+val,options)
}

 userDLDetails(val : any) : Observable<any>
{
  console.log("getUserDLDetails ")
  console.log(val);
  console.log(this.APIUrl+'/NewVulnerability/getUserDLDetails/'+val);
  return  this.http.get<any>(this.APIUrl+'/NewVulnerability/getUserDLDetails/'+val,options);
}

async verifyContEidAsPromise(val : any) {
  console.log("verify ")
  console.log(val);
  return await this.http.get<any>(this.APIUrl+'/NewVulnerability/verifyContEID/'+val,options).toPromise();
}

async userDLDetailsAsPromise(val : any){
  return await this.http.get<any>(this.APIUrl+'/NewVulnerability/getUserDLDetails/'+val,options).toPromise();
}

getReportLink() : Observable<any>{
  
  return this.http.get(this.APIUrl+'/NewVulnerability/getReportsLink',options)
  
}

getRiskTitleDropDownData() : Observable<any[]>{
  return this.http.get<any>(this.APIUrl+'/NewVulnerability/GetRiskTitleDDL',options)
  // .pipe(
  //   retry(2),
  //   catchError(this.handleError)
  // );
}

GetRiskFilteredData(FilterData : any) : Observable<any>{
  return this.http
  .put(this.APIUrl+'/NewVulnerability/GetRiskFilteredData',FilterData,options)
  .pipe(
    tap(
      () => {
        this._refreshNeeded$.next();
        this._refreshNeeded$.complete();       
      }
    )
  );
}

getSourceTitleDropDownData() : Observable<any[]>{
  console.log("url source");
  console.log(this.APIUrl+'/NewVulnerability/GetSourceVulDDL');
  return this.http.get<any>(this.APIUrl+'/NewVulnerability/GetSourceVulDDL',options)
  // .pipe(
  //   retry(2),
  //   catchError(this.handleError)
  // );
}

getTargetTitleDropDownData() : Observable<any[]>{
  console.log("url target");
  console.log(this.APIUrl+'/NewVulnerability/GetTargetVulDDL');
  return this.http.get<any>(this.APIUrl+'/NewVulnerability/GetTargetVulDDL',options)
  
}

GetSrcNACData(FilterData : any) : Observable<any>{
  return this.http
  .put(this.APIUrl+'/NewVulnerability/GetSrcNACData',FilterData,options)
  .pipe(
    tap(
      () => {
        this._refreshNeeded$.next();
        this._refreshNeeded$.complete();       
      }
    )
  );
}

GetTargetMatchData(FilterData : any) : Observable<any>{
  return this.http
  .put(this.APIUrl+'/NewVulnerability/GetTargetMatchingContData',FilterData,options)
  .pipe(
    tap(
      () => {
        this._refreshNeeded$.next();
        this._refreshNeeded$.complete();       
      }
    )
  );
}

UpdateTargetContracts(val : any){  
  return this.http
  .put(this.APIUrl+'/NewVulnerability/UpdateTargetContracts',val,options)
  
}

}
